<div class="container-fluid banner">
    <img src="../../assets/Team.jpg" class="img-responsive" style="width: 100%;">
    <div class="top-left">
        <h1 class="h1">{{brandData?.brandName}} showing <br>the way for <br>Optimal health,<br>Immunity and Care</h1>
    </div>
  </div><br>
  
<div class="container about">
    <div class="row">
        <div class="col-lg-4 col-md-4">
            <h1 class="h1">About {{brandData?.brandName}}</h1>
            <p  class="about-text">Trusting the age-old science of Ayurveda and mixing it with the modern-day ease of use, {{brandData?.brandName}} is a one of a kind company that’s here to provide the best of both worlds. Based on solid research and ongoing R&D, {{brandData?.brandName}} focuses on introducing health products and services to benefit one and all.</p>
          
        </div>
        
        <div class="col-lg-4 col-md-4 r">
            <h1 class="h1">The Idea</h1>
            <p  class="about-text">Traditional medicine has its perks and to bring it to the commoner of today was the basis on which {{brandData?.brandName}}’s foundation was built. The thought process was always on creating innovative drug discovery based on traditional global herbal knowledge. This compelling combination lead the way to develop herbal drugs and formulations offering a wide range of health benefits.</p>
       
        </div>
        <div class="col-lg-4 col-md-4">
            <h1 class="h1">The Company</h1>
            <p  class="about-text">{{brandData?.brandName}} is a nutraceutical company with a special focus on offering products and services that are backed by clinical evidence and scientific research. With a precise aim to widen the product and services portfolio, {{brandData?.brandName}} strives to maintain quality, efficacy and product ethics.</p>
        </div>
    </div>
    <div class="row">
        <div class="box">
        <h2><span class="team">The Team</span></h2>
        <p>Trusting the age-old science of Ayurveda and mixing it with the modern-day ease of use, {{brandData?.brandName}} is a one of a kind company that’s here to provide the best of both worlds.<br> Based on solid research and ongoing R&D, {{brandData?.brandName}} focuses on introducing health products and services to benefit one and all.</p>
    </div>
</div>
    <div class="row points">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <h3>EXECUTIVE TEAM</h3><span class="glyphicon glyphicon-triangle-bottom title-arrow"></span>
            <div class="row">
                <div class="col-lg-6 col-md-6">
                    <div class="row">
                        
                        <img src="assets/mick.png" class="img-responsive">
                        <figcaption>Mick Gallagher</figcaption>
                        <h5>Position:</h5>
                        <span class="glyphicon glyphicon-triangle-right"></span><p>Global CEO {{brandData?.brandFullName}}</p>
                        <h5>Background:</h5>
                        <span class="glyphicon glyphicon-triangle-right"></span><p>20+ years of experience at the intersection of Healthcare and Retail</p>
                        <span class="glyphicon glyphicon-triangle-right"></span><p>Healthcare SVP of Retail Sales for $90B segment</p>
                        <span class="glyphicon glyphicon-triangle-right"></span><p>SVP / CIO Fortune 10 Healthcare Company</p>
                        <span class="glyphicon glyphicon-triangle-right"></span><p>VP Strategic Sourcing and Process Management</p>
                        <span class="glyphicon glyphicon-triangle-right"></span><p>Management Consultant (PwC)</p>
                        <h5>Education:</h5>
                        <span class="glyphicon glyphicon-triangle-right"></span><p>Hons) in Accounting  (Abertay University, Dundee Scotland)</p>
                        <span class="glyphicon glyphicon-triangle-right"></span><p>Member of the Chartered Institute of Management Accountants</p>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="row ">
                        <img src="assets/sarat.png">
                        <figcaption>Dr. Sarat Addanki</figcaption>
                        <h5>Position:</h5>
                        <span class="glyphicon glyphicon-triangle-right"></span><p>President and Co-Founder of {{brandData?.brandFullName}}</p>
                        <h5>Background:</h5>
                        <span class="glyphicon glyphicon-triangle-right"></span><p>Co-Founder of Arsin Technology</p>
                        <span class="glyphicon glyphicon-triangle-right"></span><p>VP Quality at Prolifics</p>
                        <span class="glyphicon glyphicon-triangle-right"></span><p>15+ yrs in Healthcare and Technology</p>
                        <h5>Education:</h5>
                        <span class="glyphicon glyphicon-triangle-right"></span><p>Computer Science MVSR Engineering College – Osmania University</p>
                    </div>
                </div>
            </div>
            <div class="row">
                
                <h3>advisory TEAM</h3><span class="glyphicon glyphicon-triangle-bottom "></span>
                <!-- <h3>advisory TEAM</h3><span class="glyphicon glyphicon-triangle-bottom"></span> -->
                <div class="col-lg-6 col-md-6">
                    <div class="row">
                        <img src="assets/sridevi.png">
                        <figcaption>Sridevi Koneru</figcaption>
                        <h5>Position:</h5>
                        <span class="glyphicon glyphicon-triangle-right"></span><p>VP, Strategy and Portfolio Management, Customer Experience at Cisco</p>
                        <h5>Background:</h5>
                        <span class="glyphicon glyphicon-triangle-right"></span><p>Head of Strategy and Business Operations, Digital Media – Asobe</p>
                        <h5>Education:</h5>
                        <span class="glyphicon glyphicon-triangle-right"></span><p>MBA in Marketing, Strategy Wharton Business School</p>
                        <span class="glyphicon glyphicon-triangle-right"></span><p>MS Computer Science Santa Clara University</p>
                        <span class="glyphicon glyphicon-triangle-right"></span><p>BS Computer Science Osmania University</p>
                    
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="row">
                        <img src="assets/anurag.png">
                        <figcaption>Anurag Nallapati</figcaption>
                        <h5>Position:</h5>
                        <span class="glyphicon glyphicon-triangle-right"></span><p>Co-founder, COO at Jupiter (YC S19)</p>
                        <h5>Background:</h5>
                        <span class="glyphicon glyphicon-triangle-right"></span><p>Member – Shipmile</p>
                        <h5>Education:</h5>
                        <span class="glyphicon glyphicon-triangle-right"></span><p>MBA Stanford University Graduate School of Business</p>
                        <span class="glyphicon glyphicon-triangle-right"></span><p>M Tech Chemical Engineering Indian Institute of Technology, Madras</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <h3>Technology TEAM</h3><span class="glyphicon glyphicon-triangle-bottom title-arrow"></span>
                <div class="col-lg-6 col-md-6">
                    <div class="row">
                    
                        <img src="assets/Jaya.png">
                        <figcaption>Jaya Gummadi</figcaption>
                        <h5>Position:</h5>
                        <span class="glyphicon glyphicon-triangle-right"></span><p>CIO and Founder President of Ahyush Inc in 2017 		      (part of the {{brandData?.brandFullName}} Family)
                        </p>
                        <h5>Background:</h5>
                        <span class="glyphicon glyphicon-triangle-right"></span><p>VP of IT development of a rewards-based wellness 		      solution launched by Humana Vitality
                        </p>
                        <h5>Education:</h5>
                        <span class="glyphicon glyphicon-triangle-right"></span><p>MBA, Finance and Information Systems Eastern Michigan State University</p>
                    </div>
                </div>
                <!-- <div class="col-lg-6 col-md-6">
                    <div class="row">
                    
                        <img src="assets/sreeni.png">
                        <figcaption>Sreeni Muniswamy</figcaption>
                        <h5>Position:</h5>
                        <span class="glyphicon glyphicon-triangle-right"></span><p>Co-Founder and CTO SmartERP </p>
                    </div>
                </div> -->
            </div>
            <div class="row">
                <h3>Medical Team</h3><span class="glyphicon glyphicon-triangle-bottom"></span>
                <div class="col-lg-4 col-md-4">
                <div class="row">
                    <img src="assets/rossman.png">
                    <figcaption>Dr. Rossman</figcaption>
                    <h5>Position:</h5>
                    <span class="glyphicon glyphicon-triangle-right"></span><p>MD Marin Integrative Medicine and Medical Acupuncture</p>
                    <h5>Background:</h5>
                    <span class="glyphicon glyphicon-triangle-right"></span><p>Founder the Healing Mind</p>
                    <span class="glyphicon glyphicon-triangle-right"></span><p>Director of Marin Integrative Medicine</p>
                    <span class="glyphicon glyphicon-triangle-right"></span><p>President of the Academy of Guided Imagery</p>
                    <h5>Education:</h5>
                    <span class="glyphicon glyphicon-triangle-right"></span><p>MD University of Michigan</p>
                </div>
                </div>
                <div class="col-lg-4 col-md-4">
                <div class="row">
                    <img src="assets/gnaneswar.png">
                    <figcaption>Dr. Gnaneswar</figcaption>
                    <h5>Position:</h5>
                    <span class="glyphicon glyphicon-triangle-right"></span><p>CEO {{brandData?.brandFullName}}</p>
                    <h5>Background:</h5>
                    <span class="glyphicon glyphicon-triangle-right"></span><p>Vascular Consultant, Endovascular and Trauma Surgeon</p>
    
                    <span class="glyphicon glyphicon-triangle-right"></span><p>Surgeon Care Hospital (Hyderabad)</p>
                    <span class="glyphicon glyphicon-triangle-right"></span><p>Healthcare entrepreneur</p>
                    
                    <h5>Education:</h5>
                    <span class="glyphicon glyphicon-triangle-right"></span><p>Member of The Royal College of Surgeons Edinburgh</p>
                    <span class="glyphicon glyphicon-triangle-right"></span><p>MBA University of Leeds</p>
                </div>
                </div>
                <div class="col-lg-4 col-md-4">
                <div class="row">
                    <img src="assets/adrian.png">
                    <figcaption>Prof. Adrian Kennedy</figcaption>
                    <h5>Position:</h5>
                    <span class="glyphicon glyphicon-triangle-right"></span><p>Director of Arabian Wellness & Lifestyle Management LLC</p>
                    
                    <h5>Background:</h5>
                    <span class="glyphicon glyphicon-triangle-right"></span><p>Founder Managing Director of Lifetime Wellness Rx International Limited</p>
                    <!-- <span class="glyphicon glyphicon-triangle-right"></span><p>Founder Managing Director of Lifetime Wellness Rx International Limited</p> -->
                    <span class="glyphicon glyphicon-triangle-right"></span><p>35+ years in Health & Wellness</p>
                    <h5>Education:</h5>
                    <span class="glyphicon glyphicon-triangle-right"></span><p>PhD, Certified holistic practitioner, Lasalle University</p>
                    <span class="glyphicon glyphicon-triangle-right"></span><p>Graduated class first from Penn University</p>
                </div>
                </div>
            </div>
        </div>
        
        
    </div>

